<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button-group>
                <el-button icon="el-icon-document" size="small" :loading="exportLoading" @click="exportExcel">导出Excel</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              style="width: 100%"
            >
              <el-table-column
                prop="date"
                fixed
                label="日期"
                show-overflow-tooltip
                min-width="120"
              />
              <el-table-column
                prop="ordernum"
                fixed
                label="订单号"
                show-overflow-tooltip
                min-width="120"
              />
              <el-table-column
                fixed
                label="生产单号"
                align="center"
                show-overflow-tooltip
                min-width="120"
              >
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                align="left"
                label="客户地址"
                show-overflow-tooltip
                width="120"
              />
              <el-table-column
                prop="name"
                label="专卖店"
                align="center"
                show-overflow-tooltip
                width="120"
              />
              <el-table-column
                prop="groupName"
                label="车间"
                align="center"
                show-overflow-tooltip
                width="120"
              />
              <el-table-column
                label="外派维修"
                align="center"
                show-overflow-tooltip
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.type===1" style="color:#67C23A"><i class="el-icon-success"></i></span>
                  <span v-else style="color:#F56C6C"><i class="el-icon-error"></i></span>
                </template>
              </el-table-column>
              <el-table-column
                label="加急补单"
                align="center"
                show-overflow-tooltip
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.type===2" style="color:#67C23A"><i class="el-icon-success"></i></span>
                  <span v-else style="color:#F56C6C"><i class="el-icon-error"></i></span>
                </template>
              </el-table-column>
              <el-table-column
                label="系统未处理"
                align="center"
                show-overflow-tooltip
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.type===3" style="color:#67C23A"><i class="el-icon-success"></i></span>
                  <span v-else style="color:#F56C6C"><i class="el-icon-error"></i></span>
                </template>
              </el-table-column>
              <el-table-column
                label="紧急售后"
                align="center"
                show-overflow-tooltip
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.type===4" style="color:#67C23A"><i class="el-icon-success"></i></span>
                  <span v-else style="color:#F56C6C"><i class="el-icon-error"></i></span>
                </template>
              </el-table-column>
              <el-table-column
                label="待办事项"
                align="center"
                show-overflow-tooltip
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.type===5" style="color:#67C23A"><i class="el-icon-success"></i></span>
                  <span v-else style="color:#F56C6C"><i class="el-icon-error"></i></span>
                </template>
              </el-table-column>
              <el-table-column
                label="未接电话"
                align="center"
                show-overflow-tooltip
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.type===6" style="color:#67C23A"><i class="el-icon-success"></i></span>
                  <span v-else style="color:#F56C6C"><i class="el-icon-error"></i></span>
                </template>
              </el-table-column>
              <el-table-column
                prop="analyze"
                label="问题分析"
                align="left"
                show-overflow-tooltip
                width="200"
              />
              <el-table-column
                prop="scheme"
                align="left"
                label="解决方案"
                show-overflow-tooltip
                width="200"
              />
              <el-table-column
                fixed="right"
                prop="username"
                width="120"
                align="center"
                show-overflow-tooltip
                label="客服"
              />
              <el-table-column
                fixed="right"
                show-overflow-tooltip
                label="处理状态"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.state===1"><el-tag size="mini">已处理</el-tag></span>
                  <span v-if="scope.row.state===2"><el-tag type="danger" size="mini">未处理</el-tag></span>
                </template>
              </el-table-column>
              <el-table-column
                prop="remark"
                show-overflow-tooltip
                align="center"
                label="备注"
                width="200"
              />
              <el-table-column
                label="操作"
                align="center"
                width="120"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button :disabled="scope.row.state===1" icon="el-icon-edit" size="mini" @click="editTem(scope.row)">去处理</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-row style="margin-bottom: 10px">
        <el-col>
          <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="100px" size="small">
            <el-form-item label="日期" prop="date">
              <el-date-picker
                v-model="addForm.date"
                disabled
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item label="选择订单" prop="orderid">
              <OrderChoose :key="key" v-model="addForm.orderid" :disabled="true" :oldorderid="addForm.oldorderid" />
            </el-form-item>
            <el-form-item label="选择类型" prop="type">
              <el-select v-model="addForm.type" disabled style="width: 120px" filterable clearable>
                <el-option v-for="item in typeList" :key="item.type" :label="item.label" :value="item.type" />
              </el-select>
            </el-form-item>
            <el-form-item label="客诉问题分析" prop="analyze">
              <el-input v-model="addForm.analyze" type="textarea" disabled :rows="3" placeholder="请输入客诉问题分析" clearable show-word-limit />
            </el-form-item>
            <el-form-item label="解决方案" prop="scheme">
              <el-input v-model="addForm.scheme" type="textarea" :rows="3" placeholder="请输入解决方案" clearable show-word-limit />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="请输入备注" clearable show-word-limit />
            </el-form-item>
          </el-form>
          <div style="float: right">
            <el-button type="primary" size="mini" icon="el-icon-document-checked" :loading="btnLoading" @click="submitTem">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  addOrEditComplaintRecord,
  exportComplaintRecordOfferExcel,
  getComplaintRecordList
} from '@/api/work'
import OrderChoose from '@/components/OrderChoose/index'

export default {
  name: 'Ksjl',
  components: { OrderChoose },
  data() {
    return {
      typeList: [{
        type: 1,
        label: '外派维修'
      }, {
        type: 2,
        label: '加急补单'
      }, {
        type: 3,
        label: '系统未处理'
      }, {
        type: 4,
        label: '紧急售后'
      }, {
        type: 5,
        label: '待办事项'
      }, {
        type: 6,
        label: '未接电话'
      }],
      type: null,
      searchForm: {
        search: ''
      },
      groupList: [],
      key: '',
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      btnLoading: false,
      exportLoading: false,
      dialogTitle: '',
      dialogVisible: false,
      addForm: {
        cid: null,
        orderid: '',
        oldorderid: '',
        date: '',
        type: '',
        analyze: '',
        scheme: '',
        service: '',
        state: '',
        remark: ''
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        orderid: [{ required: true, message: '请选择订单', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        analyze: [{ required: true, message: '请输入客诉问题分析', trigger: 'blur' }],
        scheme: [{ required: true, message: '请输入解决方案', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.searchForm.search,
        iscl: 1,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getComplaintRecordList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        const data = {
          search: this.searchForm.search,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          role: this.user.role,
          iscl: 1
        }
        this.exportLoading = true
        exportComplaintRecordOfferExcel(data).then(response => {
          this.exportLoading = false
          const _this = this
          const xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              const blob = this.response
              const a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    editTem(row) {
      this.dialogTitle = '修改客诉记录'
      this.addForm.cid = row.cid
      this.addForm.date = row.date
      this.addForm.type = row.type
      this.addForm.analyze = row.analyze
      this.addForm.scheme = row.scheme
      this.addForm.sid = row.ordernum
      this.addForm.service = row.service
      this.addForm.orderid = ''
      this.addForm.oldorderid = row.orderid
      this.addForm.remark = row.remark
      this.key = new Date().getTime()
      this.dialogVisible = true
    },
    submitTem() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            const data = {
              cid: this.addForm.cid,
              date: this.addForm.date,
              type: this.addForm.type,
              analyze: this.addForm.analyze,
              scheme: this.addForm.scheme,
              sid: this.addForm.sid,
              orderid: this.addForm.orderid,
              remark: this.addForm.remark,
              service: this.addForm.service,
              userid: this.user.dUserid
            }
            this.btnLoading = true
            addOrEditComplaintRecord(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
